import React from "react"

/* Hallmark · component: footer React (glow rotatorio + 4 columnas) · theme: tokens del proyecto
 * El estampado (.brand-glow) vive en src/index.css — adaptado de Uiverse.io by ariba_9087.
 * Recibe props desde footer.php vía data-props (JSON) para no hardcodear URLs de WP. */

const FacebookIcon = () => (
  <svg fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
    <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
  </svg>
)

const InstagramIcon = () => (
  <svg fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
    <path d="M12 0C8.74 0 8.333.015 7.053.072 5.775.132 4.905.333 4.14.63c-.789.306-1.459.717-2.126 1.384S.935 3.35.63 4.14C.333 4.905.131 5.775.072 7.053.012 8.333 0 8.74 0 12s.015 3.667.072 4.947c.06 1.277.261 2.148.558 2.913.306.788.717 1.459 1.384 2.126.667.666 1.336 1.079 2.126 1.384.766.296 1.636.499 2.913.558C8.333 23.988 8.74 24 12 24s3.667-.015 4.947-.072c1.277-.06 2.148-.262 2.913-.558.788-.306 1.459-.718 2.126-1.384.666-.667 1.079-1.335 1.384-2.126.296-.765.499-1.636.558-2.913.06-1.28.072-1.687.072-4.947s-.015-3.667-.072-4.947c-.06-1.277-.262-2.149-.558-2.913-.306-.789-.718-1.459-1.384-2.126C21.319 1.347 20.651.935 19.86.63c-.765-.297-1.636-.499-2.913-.558C15.667.012 15.26 0 12 0zm0 2.16c3.203 0 3.585.016 4.85.071 1.17.055 1.805.249 2.227.415.562.217.96.477 1.382.896.419.42.679.819.896 1.381.164.422.36 1.057.413 2.227.057 1.266.07 1.646.07 4.85s-.015 3.585-.074 4.85c-.061 1.17-.256 1.805-.421 2.227-.224.562-.479.96-.899 1.382-.419.419-.824.679-1.38.896-.42.164-1.065.36-2.235.413-1.274.057-1.649.07-4.859.07-3.211 0-3.586-.015-4.859-.074-1.171-.061-1.816-.256-2.236-.421-.569-.224-.96-.479-1.379-.899-.421-.419-.69-.824-.9-1.38-.165-.42-.359-1.065-.42-2.235-.045-1.26-.061-1.649-.061-4.844 0-3.196.016-3.586.061-4.861.061-1.17.255-1.814.42-2.234.21-.57.479-.96.9-1.381.419-.419.81-.689 1.379-.898.42-.166 1.051-.361 2.221-.421 1.275-.045 1.65-.06 4.859-.06l.045.03zm0 3.678c-3.405 0-6.162 2.76-6.162 6.162 0 3.405 2.76 6.162 6.162 6.162 3.405 0 6.162-2.76 6.162-6.162 0-3.405-2.76-6.162-6.162-6.162zM12 16c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4zm7.846-10.405c0 .795-.646 1.44-1.44 1.44-.795 0-1.44-.646-1.44-1.44 0-.794.646-1.439 1.44-1.439.793-.001 1.44.645 1.44 1.439z"/>
  </svg>
)

const GoogleIcon = () => (
  <svg fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
    <path d="M12.48 10.92v3.28h7.84c-.24 1.84-.853 3.187-1.787 4.133-1.147 1.147-2.933 2.4-6.053 2.4-4.827 0-8.6-3.893-8.6-8.72s3.773-8.72 8.6-8.72c2.6 0 4.507 1.027 5.907 2.347l2.307-2.307C18.747 1.44 16.133 0 12.48 0 5.867 0 .307 5.387.307 12s5.56 12 12.173 12c3.573 0 6.267-1.173 8.373-3.36 2.16-2.16 2.84-5.213 2.84-7.667 0-.76-.053-1.467-.173-2.053H12.48z" />
  </svg>
)

const LINK = "hover:text-acento active:text-acento-oscuro transition-colors focus-visible:outline-2 focus-visible:outline-acento focus-visible:outline-offset-4 rounded-sm"

function Footer({
  homeUrl = "/",
  menuUrl = "/menu/",
  locationsUrl = "/locations/",
  contactUrl = "/contact/",
  toastUrl = "https://order.toasttab.com/online/bistro-brunch-5950-w-mcdowell-rd-suite-101",
  brandLogo = "",
  phoneDisplay = "480-993-8093", // TODO Pendiente #1: confirmar teléfono oficial único
  phoneHref = "tel:+14809938093",
  email = "hello@bistrobrunchaz.com",
  facebookUrl = "https://www.facebook.com/profile.php?id=61584104999791",
  instagramUrl = "https://www.instagram.com/bistro.brunchh/",
  googleUrl = "#", // TODO: enlace al perfil de Google Business
  addressLine = "5950 W McDowell Rd Suite 101, Phoenix, AZ 85035",
  mapsUrl = "https://maps.google.com/?q=Bistro+Brunch+5950+W+McDowell+Rd+Suite+101+Phoenix+AZ+85035",
}) {
  const explore = [
    { label: "Home", href: homeUrl },
    { label: "Menu", href: menuUrl },
    { label: "Order Online", href: toastUrl, external: true },
    { label: "Location", href: locationsUrl },
    { label: "Contact", href: contactUrl },
  ]

  return (
    <footer className="brand-estampado relative mt-16">
      {/* Estampado: capas cónicas giratorias con blur */}
      <div className="brand-glow" aria-hidden="true"></div>

      <div className="relative max-w-6xl mx-auto px-4 pt-14 pb-8">
        <div className="grid gap-10 md:grid-cols-2 lg:grid-cols-4">

          {/* Marca */}
          <div>
            <a href={homeUrl} className="inline-block focus-visible:outline-2 focus-visible:outline-acento focus-visible:outline-offset-4 rounded-sm">
              {brandLogo
                ? <img src={brandLogo} alt="Bistro Brunch Cocina Mexicana" className="h-14 w-auto" />
                : <span className="font-bold text-2xl text-acento">Bistro Brunch</span>}
            </a>
            <div className="mt-5 flex items-center gap-3">
              <a href={facebookUrl} target="_blank" rel="noopener noreferrer"
                 className="social-dot social-dot-fb focus-visible:outline-2 focus-visible:outline-acento focus-visible:outline-offset-2"
                 aria-label="Bistro Brunch on Facebook (opens in a new tab)">
                <FacebookIcon />
              </a>
              <a href={instagramUrl} target="_blank" rel="noopener noreferrer"
                 className="social-dot social-dot-ig focus-visible:outline-2 focus-visible:outline-acento focus-visible:outline-offset-2"
                 aria-label="Bistro Brunch on Instagram (opens in a new tab)">
                <InstagramIcon />
              </a>
              <a href={googleUrl} target="_blank" rel="noopener noreferrer"
                 className="social-dot social-dot-gg focus-visible:outline-2 focus-visible:outline-acento focus-visible:outline-offset-2"
                 aria-label="Bistro Brunch on Google (opens in a new tab)">
                <GoogleIcon />
              </a>
            </div>
          </div>

          {/* Explora */}
          <nav aria-label="Footer navigation">
            <h2 className="text-sm font-semibold uppercase tracking-wider text-carbon">Explore</h2>
            <ul className="mt-4 space-y-2.5 text-sm text-cafe-olla">
              {explore.map(item => (
                <li key={item.label}>
                  <a
                    href={item.href}
                    className={LINK}
                    {...(item.external ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                  >
                    {item.label}
                  </a>
                </li>
              ))}
            </ul>
          </nav>

          {/* Contacto */}
          <div>
            <h2 className="text-sm font-semibold uppercase tracking-wider text-carbon">Contact</h2>
            <ul className="mt-4 space-y-2.5 text-sm text-cafe-olla">
              <li><a href={phoneHref} className={LINK}>{phoneDisplay}</a></li>
              <li><a href={`mailto:${email}`} className={LINK}>{email}</a></li>
              <li>
                <a href={mapsUrl} target="_blank" rel="noopener noreferrer" className={LINK}>{addressLine}</a>
              </li>
            </ul>
          </div>

          {/* Horario */}
          <div>
            <h2 className="text-sm font-semibold uppercase tracking-wider text-carbon">Hours</h2>
            <ul className="mt-4 space-y-2.5 text-sm text-cafe-olla">
              <li className="flex justify-between gap-4"><span>Mon – Fri</span><span className="font-medium">7:00 AM – 2:00 PM</span></li>
              <li className="flex justify-between gap-4"><span>Sat – Sun</span><span className="font-medium">7:00 AM – 3:00 PM</span></li>
            </ul>
            <a href={toastUrl} target="_blank" rel="noopener noreferrer"
               className="btn-order mt-5 inline-flex items-center rounded-full text-white text-sm font-semibold px-5 py-2.5 focus-visible:outline-2 focus-visible:outline-acento-oscuro focus-visible:outline-offset-2">
              Order Online
            </a>
          </div>

        </div>

        {/* Barra inferior */}
        <div className="mt-12 pt-6 border-t border-cafe-olla/15 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-cafe-olla">
          <p>&copy; {new Date().getFullYear()} Bistro Brunch Cocina Mexicana. All rights reserved.</p>
          <p>
            Site by{" "}
            <a href="https://828marketingsolutions.com" target="_blank" rel="noopener noreferrer" className={`font-medium ${LINK}`}>
              828 Marketing Solutions
            </a>
          </p>
        </div>
      </div>
    </footer>
  )
}

export default Footer